// src/api/productApi.js
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

// Obtener todos los productos
export const getProducts = async () => {
  const token = localStorage.getItem("token");
  if (!token) {
    console.error("Token not found, please log in");
    return null;
  }

  const response = await axios.get(`${API_URL}/api/productos`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return response.data;
};

// Añadir un nuevo producto
export const addProduct = async (product) => {
  const token = localStorage.getItem("token");
  if (!token) {
    console.error("Token not found, please log in");
    return null;
  }

  const response = await axios.post(`${API_URL}/api/productos`, product, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return response.data;
};

// Obtener producto por ID
export const getProductById = async (id) => {
  const token = localStorage.getItem("token");
  if (!token) {
    console.error("Token not found, please log in");
    return null;
  }

  const response = await axios.get(`${API_URL}/api/productos/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return response.data;
};

export const getProductFileContext = getProductById;

// Actualizar un producto
export const updateProduct = async (id, updatedProduct) => {
  const token = localStorage.getItem("token");
  if (!token) {
    console.error("Token not found, please log in");
    return null;
  }

  const response = await axios.put(
    `${API_URL}/api/productos/${id}`,
    updatedProduct,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return response.data;
};

// Eliminar un producto
export const deleteProduct = async (id) => {
  const token = localStorage.getItem("token");
  if (!token) {
    console.error("Token not found, please log in");
    return null;
  }

  const response = await axios.delete(`${API_URL}/api/productos/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return response.data;
};

// Filtra los Diseñadores
export const getDesigners = async () => {
  const token = localStorage.getItem("token");
  if (!token) {
    console.error("Token not found, please log in");
    return null;
  }

  const response = await axios.get(`${API_URL}/api/users/designers`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};
